<template>
  <div id="user-fly-talks">
    <div class="title layout-spacing-big live-tag">Fly talks</div>
    <div class="layout-spacing">
      <Description v-if="features.description" />
      <FlyTalkGroups v-if="features.groups" />
    </div>
  </div>
</template>

<script>
import Router from '../../../src/router.js';
import Description from './Fly-talks/Description';
import FlyTalkGroups from './Fly-talks/FlyTalkGroups';

export default {
  name: 'FlyTalks',
  components: { Description, FlyTalkGroups },
  data() {
    return {
      route: 'app/flyTalks',
      features: {},
    };
  },
  created() {
    this.$axios.get(`${this.$API_URL}/features/route`, { params: { route: this.route } }).then(response => {
      this.features = response.data.features.reduce((acc, x) => {
        acc[x.path.replace(`${this.route}/`, '')] = x.isActive;

        return acc;
      }, {});
    });
    this.$axios.get(`${this.$API_URL}/features/route`, { params: { route: 'app/navigation' } }).then(response => {
      if (!response.data.features.find(f => f.path === 'app/navigation/flyTalks').isActive) {
        Router.push('/app');
      }
    });
  },
};
</script>

<style scoped>
#user-fly-talks {
  padding: 48px 24px 100px;
}

.title {
  font-weight: 800;
  font-size: 32px;
  line-height: 38px;
  color: #ffffff;
  margin-bottom: 64px;
}

@media screen and (min-width: 1024px) {
  #user-fly-talks {
    padding: 160px 100px;
  }
}
</style>
